// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-to-clipboard--active .copy-to-clipboard__icon {
  color: var(--color-success-content-base);
}
.copy-to-clipboard--active:hover .copy-to-clipboard__icon {
  color: var(--color-success-content-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/copy-to-clipboard/CopyToClipboard.less"],"names":[],"mappings":"AACE;EAEI,wCAAA;AADN;AAII;EAEI,wCAAA;AAHR","sourcesContent":[".copy-to-clipboard {\n  &--active {\n    .copy-to-clipboard__icon {\n      color: var(--color-success-content-base);\n    }\n\n    &:hover {\n      .copy-to-clipboard__icon {\n        color: var(--color-success-content-base);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
